/**
* Copyright (c) 2025 Bytedance, Inc. and its affiliates.
* SPDX-License-Identifier: Apache-2.0
*/
const parseUrl = (url)=>{
    try {
        return new URL(url);
    } catch  {
        return null;
    }
};
const shouldSkipDomain = (url)=>{
    const parsed = parseUrl(url);
    if (!parsed) return true;
    const { hostname } = parsed;
    return [
        'reddit.com',
        'www.reddit.com',
        'x.com',
        'twitter.com',
        'www.twitter.com',
        'youtube.com',
        'www.youtube.com'
    ].includes(hostname);
};
export { shouldSkipDomain };

//# sourceMappingURL=url.mjs.map